/**
 * Responsive Video - Poster Image Handler
 * 動画再生時にポスター画像を非表示にする
 */

class ResponsiveVideoManager {
  constructor() {
    this.init();
  }

  init() {
    // DOMContentLoaded後に初期化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupVideos());
    } else {
      this.setupVideos();
    }
  }

  setupVideos() {
    const videos = document.querySelectorAll('.s-video');

    videos.forEach(video => {
      // 前の要素がポスター画像かチェック
      const wrapper = video.closest('[class*="wrapper"]') || video.parentElement;
      const poster = wrapper?.querySelector('.s-video-poster');

      if (!poster) return;

      // 動画再生時にポスターを非表示
      video.addEventListener('play', () => {
        this.hidePoster(poster);
      }, { once: false });

      // 動画が読み込まれて再生可能になったらポスターを非表示
      video.addEventListener('canplay', () => {
        // autoplayの場合、canplayで即座に非表示
        if (video.autoplay) {
          this.hidePoster(poster);
        }
      }, { once: true });

      // loadeddata イベントでも確認（より早いタイミング）
      video.addEventListener('loadeddata', () => {
        if (video.autoplay) {
          this.hidePoster(poster);
        }
      }, { once: true });
    });
  }

  hidePoster(posterElement) {
    if (!posterElement) return;

    // フェードアウトアニメーション
    posterElement.style.transition = 'opacity 0.3s ease-out';
    posterElement.style.opacity = '0';

    // アニメーション完了後に完全に非表示
    setTimeout(() => {
      posterElement.style.display = 'none';
    }, 300);
  }
}

// インスタンス化して実行
new ResponsiveVideoManager();
